/**
 * @fileoverview Agent definition for chapter-splitter-v2.
 *
 * @deprecated Replaced by the split-point-detector-v1 + html-split + chapter-rebuilder-v1
 * pipeline. The monolithic approach (detect + rewrite + metadata in one pass) has been
 * decomposed into three focused steps. See use-chapter-splitter-v2.ts workflow hook.
 *
 * @category narrative.chapters.operations
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-splitter-v2',
  kind: 'primitive',
  name: 'Chapter Splitter',
  description: 'Analyzes a chapter and intelligently splits it into two new, distinct chapters.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'deprecated',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.operations',
    usedBy: [
      'primitives/use-chapter-splitter-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-entity-detector-v2',
    ],
  },
};
